import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { CategoryConsumer, CategoryProvider } from '../../../../../CategoryContext'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteCategory = ({
                          index, data, setData, count, setCount, handleNotificationCall,
                          handleDeleteCategoryDialog, viewDeleteCategoryDialog, openDeleteCategoryDialog
                        }) => {
  const classes = useStyles()

  return (
    <CategoryProvider pageAction={'delete'} handleNotificationCall={handleNotificationCall}>
      <CategoryConsumer>
        {({ deleteCategoryLoading, handleDeleteCategory }) => (
          <>
            {!!viewDeleteCategoryDialog &&
            <Dialog
              keepMounted
              fullWidth
              maxWidth={'sm'}
              open={openDeleteCategoryDialog}
              classes={{ paper: classes.NewOrderDialogPaper }}
              TransitionComponent={Transition}
              onClose={handleDeleteCategoryDialog}
              aria-labelledby="BasicInfoDialog"
              aria-describedby="BasicInfoDialog"
            >
              <IconButton
                edge={false}
                className={classes.NewOrderDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleDeleteCategoryDialog}
              >
                <CloseIcon/>
              </IconButton>
              <DialogContent className={classes.NewOrderDialogContent}>
                {!!deleteCategoryLoading && <FormLoader loading={true}/>}
                <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Category.DeleteMessage' values={{ title: data[index].name }}/></p>
                </Box>
              </DialogContent>
              <DialogActions className={classes.NewOrderDialogFooter}>
                <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                        onClick={() => {
                          handleDeleteCategory(index, data, setData, count, setCount, handleDeleteCategoryDialog)
                        }}>
                  <FormattedMessage id='Page.Action.Delete'/>
                </Button>
                <Button onClick={handleDeleteCategoryDialog} color="primary">
                  <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
                </Button>
              </DialogActions>
            </Dialog>
            }
          </>
        )}
      </CategoryConsumer>
    </CategoryProvider>
  )
}

export default DeleteCategory
